import get from 'lodash.get';

import { HIDE_GLOBAL_MENU_NAV } from 'lib/brandFeatures.json';
import { explodeFeatureFlagValue } from 'lib/cookies';
import { getFeatureConfigForBrand } from 'lib/getFeatureStatus';

const featureFlagCookieName = 'featureFlag';
const singleNavTestName = 'singlenav';

const useSingleNav = (vertical, cookies) => {
  if (!cookies || typeof cookies.get !== 'function') {
    return false;
  }

  const hideGlobalNavConf = getFeatureConfigForBrand(HIDE_GLOBAL_MENU_NAV, vertical);

  // If our vertical has no configuration for the test then no Single Nav should be
  // enabled.
  if (!hideGlobalNavConf) {
    return false;
  }

  // If our vertical is not yet in the `testPhase` then no Single Nav should be
  // enabled.
  if (get(hideGlobalNavConf, 'testPhase', undefined) !== true) {
    return false;
  }

  // If our vertical is in the `testPhase` then we should check the cookie to determine
  // eligibility.
  const featureFlagCookie = cookies.get(featureFlagCookieName);
  if (!featureFlagCookie) {
    return false;
  }

  const featureFlag = explodeFeatureFlagValue(featureFlagCookie);
  return get(featureFlag, singleNavTestName, false) === 'true';
};

export {
  useSingleNav,
};
